export * from './IconOtherFile';
export { default as IconOtherFile } from './IconOtherFile';
